import jwt from 'jsonwebtoken';
import { MONTH, COURTESY_EMAIL, EXTERNAL_USER_EMAIL } from '../consts';
const formatTwo = (n) => (n > 9 ? `${n}` : `0${n}`);

export default {
  methods: {
    toast({ title, description, variant = 'success' }) {
      this.$bvToast.toast(description, {
        title,
        toaster: 'b-toaster-bottom-center',
        solid: true,
        appendToast: true,
        variant,
      })
    },
    isDummyEmail(email) {
      return email === EXTERNAL_USER_EMAIL || email === COURTESY_EMAIL;
    },
    isCourtesyEmail(email) {
      return email === COURTESY_EMAIL;
    },
    getMetaValue(mtdata, key) {
      const obj = mtdata.find((el) => el.key === key);
      return (obj && obj.charValue) || (obj && obj.value) || null;
    },
    signToken(payload) {
      return jwt.sign(payload, 'jnputin');
    },
    dateFriend(date) {
      const dtr = date.replace(/-/g, '/');
      const d = new Date(dtr);
      const weekday = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic'];
      const dtFriend = `${weekday[d.getDay()]} ${formatTwo(d.getDate())} de ${
        months[d.getMonth()]
      }. ${d.getFullYear()}`;
      return dtFriend;
    },
    hourFriend(hour) {
      const patrs = hour.split('-');
      return `${this.parseHourString(patrs[0])} - ${this.parseHourString(patrs[1])}`;
    },
    parseHourString(time) {
      const patrs = time.split(':');
      let ampm = ' AM';
      if (patrs[0] >= 12) {
        ampm = ' PM';
      }
      if (patrs[0] > 12) {
        patrs[0] -= 12;
      }
      const formattedTime = `${formatTwo(parseInt(patrs[0], 0))}:${patrs[1]}${ampm}`;
      return formattedTime;
    },
    formatDate(date) {
      const d = new Date(date);
      let month = `${d.getMonth() + 1}`;
      let day = `${d.getDate()}`;
      const year = d.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join('-');
    },
    getFormatDay(date) {
      const d = new Date(date);
      return `${d.getDate()}`;
    },
    getFormatMonth(date) {
      const d = new Date(date);
      return MONTH[`${d.getMonth() + 1}`];
    },
    numberFormat(value) {
      return Number.parseFloat(value).toFixed(2);
    },
    getCartEvents(events) {
      if (!events.length) return [];
      const arrByEvent = events.slice().groupBy('adhId');
      return Object.keys(arrByEvent).map((key) => {
        const firstEl = arrByEvent[key][0];
        return {
          activityId: firstEl.activityId,
          adhId: parseInt(key, 0),
          title: firstEl.title,
          imageUrl: firstEl.imageUrl,
          day: firstEl.date,
          hour: `${firstEl.timeStart} - ${firstEl.timeEnd}`,
          types: arrByEvent[key],
          coupon: firstEl.coupon,
        };
      });
    },
    dataEventsSend(value) {
      return value.map((item) => {
        const types = item.types.map((type) => {
          const { value = '', minQuantityPerOrder = 0, ticketTypeId = 0, type: itemType } = type;
          let quantity = value;
          if (itemType === 'combo') {
            quantity = parseInt(value) * minQuantityPerOrder;
          } else if (itemType === 'venue') {
            quantity = value.split(',').length;
          }
          return {
            ticketTypeId,
            quantity,
            seats: itemType !== 'venue' ? null : value.toUpperCase()
          };
        });
        return {
          id: item.activityId,
          activity_date_hour_id: item.adhId,
          types,
          coupon: item.coupon,
        };
      });
    },
    generateId() {
      const id = Math.random().toString(36).substr(2, 18);
      return id;
    },
    validateEmail(email) {
      var re = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,10}$/;
      return re.test(email);
    },
    validateNumber(event) {
      const { keyCode } = event;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    validateText(event, value) {
      const regular = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+$/;
      const regex = new RegExp(regular);
      const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key) || (value[0] === undefined && /^\s/.test(key))) {
        event.preventDefault();
        return false;
      }
      return true;
    },
    handlePaste(event, type = 'text') {
      const pasted = (event.clipboardData || window.clipboardData).getData('text');
      let regex;
      switch (type) {
        case 'text':
          regex = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+$/;
          break;
        case 'alphanumeric':
          regex = /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ ]+$/;
          break;
        case 'numeric':
          regex = /^[0-9]+$/;
          break;
        case 'email':
          regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          break;
        default:
          regex = /.*/;
          break;
      }

      if (!regex.test(pasted)) {
        event.preventDefault();
      }
    },
    getTicketId(transactionCode, children) {
      return transactionCode ? transactionCode : children.find((child) => child.isPayed === 0 && child.isAnuled === 0);
    },
    buildUrl(baseUrl, path, params) {
      const url = new URL(`${baseUrl}${path}`);
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined) {
          url.searchParams.append(key, params[key]);
        }
      });
      return url.toString();
    },
    getGenerateUrlSecurePayment(
      children,
      pathUrl = null,
      transactionCode = null,
      pathReturnUrl = null,
      isMultiPayment = null,
      otherPayment = null,
    ) {
      const { VUE_APP_SECURE_PAYMENT, VUE_APP_URL } = process.env;
      const userAuth = this.$store.state.auth;
      const ticketId = this.getTicketId(transactionCode, children);

      if (ticketId && userAuth) {
        const params = {
          session: userAuth.token,
          source: 'box-office-ministerio',
          returnUrl: pathReturnUrl ? `${VUE_APP_URL}${pathReturnUrl}` : undefined,
          isMultiPayment: isMultiPayment || undefined,
          callbackUrl: pathUrl ? `${VUE_APP_URL}${pathUrl}` : undefined,
          otherPayment: otherPayment || undefined,
        };
        return this.buildUrl(VUE_APP_SECURE_PAYMENT, `/${ticketId.id}`, params);
      }
      return null;
    },
    formatDateMixin(date) {
      if (date) {
        let format = date.split('-');
        let year = format[0];
        let month = format[1];
        let day = format[2];
        return day + '/' + month + '/' + year;
      }
      return '';
    },
    formattedDateTime(date) {
      if (date) {
        const dateTime = new Date(date);
        dateTime.setHours(dateTime.getHours() + 5);
        const day = dateTime.getDate().toString().padStart(2, '0');
        const month = (dateTime.getMonth() + 1).toString().padStart(2, '0');
        const year = dateTime.getFullYear();
        const hours = dateTime.getHours().toString().padStart(2, '0'); // Use getUTCHours to get hours in UTC
        const minutes = dateTime.getMinutes().toString().padStart(2, '0');
        const seconds = dateTime.getSeconds().toString().padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
      } else {
        return '';
      }
    },
    formatDateHourMixin(date) {
      if (date) {
        let convertDate = date.split(' ');
        let dateTo = this.formatDateMixin(convertDate[0]);
        let hourTo = convertDate[1];
        return `${dateTo} ${hourTo}`;
      } else {
        return '';
      }
    },
    formatNacionality(iso) {
      let filterCountry = this.$store.getters.getListCountriesS3.filter((el) => el.iso == iso)[0];
      if (filterCountry) {
        return filterCountry;
      } else return iso;
    },
    disableDayForAdult(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      today.setFullYear(today.getFullYear() - 18);
      return date >= today;
    },
    disableDayForChild(date) {
      const to = new Date();
      to.setHours(0, 0, 0, 0);
      to.setFullYear(to.getFullYear() - 17);
      const from = new Date();
      from.setHours(0, 0, 0, 0);
      from.setFullYear(from.getFullYear() - 3);
      return date < to || date > from;
    },
    disableBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    truncateHtml(html, length) {
      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      let text = tempDiv.textContent || tempDiv.innerText;
      if (text.length > length) {
        text = text.slice(0, length) + '...';
      }
      tempDiv.innerHTML = text;
      return tempDiv.innerHTML;
    },
    getMetadataValue(metadata, key) {
      if (!metadata || typeof metadata !== 'object') {
        return null;
      }
      return key in metadata ? metadata[key] : null;
    }
  },
};
